<template>
  <drr
    :id="ID"
    :x="parseInt(Left)"
    :y="parseInt(Top)"
    :w="parseInt(Width)"
    :h="parseInt(Height)"
    :angle="parseInt(Angle)"
    :aspectRatio="false"
    :z="0"
    :selectable="Enabled"
    v-on:resizestop="resize"
    v-on:dragstop="drag"
    v-on:rotatestop="rotate"
    class="component"
  >
    <div class="center">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        :id="`${this.ID}-svg`"
        version="1.1"
        viewBox="0 0 13.229167 6.3500001"
        :height="Height"
        :width="Width"
        sodipodi:docname="bomba_agua_ligada.svg"
        inkscape:label="AreaPump"
        inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
      >
        <sodipodi:namedview
          pagecolor="#ffffff"
          borderColor="#666666"
          borderopacity="1"
          objecttolerance="10"
          gridtolerance="10"
          guidetolerance="10"
          inkscape:pageopacity="0"
          inkscape:pageshadow="2"
          inkscape:window-width="1366"
          inkscape:window-height="705"
          id="namedview49"
          showgrid="false"
          inkscape:zoom="7.62"
          inkscape:cx="25"
          inkscape:cy="12"
          inkscape:window-x="-8"
          inkscape:window-y="79"
          inkscape:window-maximized="1"
          inkscape:current-layer="layer1"
        />
        <defs id="defs13224" />
        <metadata id="metadata13227">
          <rdf:RDF>
            <cc:Work rdf:about>
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
              <dc:title />
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <g
          style="display:inline"
          transform="translate(0,-290.65001)"
          id="layer1"
          inkscape:label="AreaPump"
        >
          <g
            transform="matrix(0.32475461,0,0,0.32475461,-150.78713,276.15732)"
            id="Layer1051"
            inkscape:label="Pump"
          >
            <path
              d="m 479.6901,49.9015 h 1.3311 v 0.5365 h 12.2999 c 0.7413,3.9939 0.5511,7.8244 -0.2323,11.5507 h -10.8697 l -1.6633,-0.8788 v 0.7203 h -0.8657 c 0.3417,-4.0166 0.3718,-7.9964 0,-11.9287 z"
              style="fill:#c6d0da;fill-rule:evenodd"
              id="path9927"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 479.4467,50.1075 c 0,-0.0811 0.1622,-0.206 0.2434,-0.206 0.3693,3.9411 0.3404,7.9201 0,11.9287 -0.0812,0 -0.2434,-0.0801 -0.2434,-0.1613 v -0.0265 c 0.168,-3.738 0.2279,-7.6197 0,-11.3909 0,-0.1167 0,-0.0229 0,-0.144 z"
              style="fill:#6f7473;fill-rule:evenodd"
              id="path9929"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 482.2191,61.9887 h 10.4467 l 0.3723,0.4089 v 0.7982 h -2.7172 v -0.2549 h -5.2563 c 0,0.0849 0,0.1699 0,0.2549 h -2.8455 z"
              style="fill:#939ea3;fill-rule:evenodd"
              id="path9931"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 499.2695,49.1956 -1.2114,0.4902 -1.5486,-0.4902 c 0.6678,4.2191 0.6745,8.483 0,12.7931 l 1.4894,-0.5408 1.2706,0.5408 c 0.7372,-4.8633 0.7052,-9.1016 0,-12.7931 z"
              style="fill:#c6d0da;fill-rule:evenodd"
              id="path9933"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 499.2695,49.1956 -1.2114,0.4902 c 0.4968,3.9402 0.5387,7.895 -0.0592,11.7621 l 1.2706,0.5408 c 0.7372,-4.8633 0.7052,-9.1016 0,-12.7931 z"
              style="fill:#b2c0cb;fill-rule:evenodd"
              id="path9935"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 502.5248,49.1956 h -3.2553 c 0.6395,3.389 0.7433,7.5113 0,12.7931 h 3.2553 c 0.7617,-4.2643 0.8157,-8.5287 0,-12.7931 z"
              style="fill:#939ea3;fill-rule:evenodd"
              id="path9937"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 502.4638,49.1956 c 0.8914,4.3556 0.8793,8.6187 0,12.7931 2.6225,-4.1458 2.0774,-10.1876 0,-12.7931 z"
              style="fill:#c7d0da;fill-rule:evenodd"
              id="path9939"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 472.8293,50.7263 h 6.6446 c 0.2856,2.7334 0.2736,6.039 10e-4,10.2581 l -0.4742,-0.3265 v -0.6021 h -6.2362 c -0.0565,5e-4 -0.0584,0.0016 -0.0595,-0.056 v -9.122 c -0.004,-0.1295 0.0178,-0.1526 0.1241,-0.1515 z"
              style="fill:#3e4855;fill-rule:evenodd"
              id="path9941"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 476.7568,51.8332 h 2.0084 c 0.1043,0 0.9249,0.3897 0.9249,0.4939 v 6.6305 c 0,0.1043 -0.8175,0.4559 -0.9218,0.4559 h -2.0115 c -0.1042,0 -0.1896,-0.0854 -0.1896,-0.1897 v -7.2009 c 0,-0.1043 0.0853,-0.1897 0.1896,-0.1897 z"
              style="fill:#6f7473;fill-rule:evenodd"
              id="path9943"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 478.2488,53.6544 c 0.454,-0.0799 0.8986,-0.1905 1.3272,-0.3549 0.0237,1.4775 0.0364,2.8739 0,4.1239 -0.416,-0.1333 -0.811,-0.2248 -1.3272,-0.2408 z"
              style="fill:#3e4855;fill-rule:evenodd"
              id="path9945"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 475.0797,60.0558 v 0.5455 c 0,0.2206 -0.1804,0.401 -0.401,0.401 h -1.0739 c -0.2206,0 -0.4011,-0.1804 -0.4011,-0.401 v -0.5455 z"
              style="fill:#6f7473;fill-rule:evenodd"
              id="path9947"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 472.7052,52.6997 h -1.6565 c 0.274,1.9263 0.233,3.7639 -0.01,5.5309 h 1.666 z"
              style="fill:#c7d1db;fill-rule:evenodd"
              id="path9949"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 471.0487,52.6997 c -0.2677,0.2161 -0.4998,0.3663 -0.5187,0.7721 0.002,0.0655 0.0279,0.1427 0.1192,0.1533 0.1433,1.2371 0.1272,2.4642 0,3.6844 -0.0844,0.0373 -0.1276,0.1153 -0.1275,0.1863 -0.0182,0.3579 0.1301,0.5037 0.5175,0.7348 0.2805,-1.9392 0.2501,-3.7947 0.01,-5.5309 z"
              style="fill:#6f7473;fill-rule:evenodd"
              id="path9951"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 467.4211,53.6251 h 3.2281 c 0.1374,1.2182 0.1592,2.4448 0,3.6844 h -3.2281 c 0.171,-1.2146 0.1501,-2.4444 0,-3.6844 z"
              style="fill:#c6d0da;fill-rule:evenodd"
              id="path9953"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 467.1675,57.4321 c 0.0949,0.0027 0.2151,-0.0254 0.2476,-0.1329 0.1778,-0.5876 0.1462,-2.9533 -10e-4,-3.6573 -0.0294,-0.1401 -0.1543,-0.1963 -0.2463,-0.1985 0.1475,1.3451 0.1736,2.6775 0,3.9887 z"
              style="fill:#676a6c;fill-rule:evenodd"
              id="path9955"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 467.1675,53.4434 h -1.876 c 0.1374,1.3399 0.1596,2.6711 0,3.9887 h 1.876 c 0.1867,-1.2943 0.172,-2.6267 0,-3.9887 z"
              style="fill:#c6d0da;fill-rule:evenodd"
              id="path9957"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 465.2644,53.4434 a 0.1387,1.9944 0 0 1 0.1387,1.9944 0.1387,1.9944 0 1 1 -0.1387,-1.9944 z"
              style="fill:#3e4855;fill-rule:evenodd"
              id="path9959"
              inkscape:connector-curvature="0"
            />
            <g id="Layer1052">
              <path
                d="m 481.1143,51.492 1.2978,0.1099 11.3697,0.0374 -0.0204,0.7424 -11.81,-0.102 -0.8447,-0.0582 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9961"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 482.3233,50.3344 11.4422,0.0297 0.0211,1.1162 -10.5574,-0.0507 0.021,-0.534 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9963"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1119,52.4531 1.255,0.1036 11.4168,3e-4 -0.0243,0.9919 -11.4515,-0.085 c -0.401,-0.0486 -0.8021,-0.0972 -1.2031,-0.1458 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9965"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1098,55.4511 1.2661,-0.0019 11.5178,3e-4 -0.005,0.7458 -11.5529,-0.0851 c -0.4045,-0.0486 -0.8091,-0.0972 -1.2137,-0.1458 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9967"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1117,58.0471 1.266,-0.0019 11.5178,4e-4 -3e-4,0.619 -11.5528,-0.0175 c -0.4046,-0.0486 -0.8134,-0.038 -1.2179,-0.0866 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9969"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.0599,53.5746 1.2572,0.0788 11.5181,0.1017 -0.0407,0.6272 -11.571,-0.0433 c -0.4042,-0.0409 -0.7659,-0.0501 -1.1702,-0.091 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9971"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.108,56.2636 1.2572,0.0788 11.5249,0.0337 -0.0391,0.6022 -11.5709,-0.0433 c -0.4043,-0.0408 -0.766,-0.0501 -1.1703,-0.091 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9973"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1098,58.7582 1.2572,0.0788 11.5249,0.0337 -0.0391,0.6487 -11.5709,-0.0432 c -0.4043,-0.0409 -0.766,-0.0502 -1.1702,-0.0911 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9975"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1101,54.4569 1.2572,0.0788 11.5181,0.1017 -0.0407,0.6271 -11.571,-0.0432 c -0.4042,-0.0409 -0.7659,-0.0501 -1.1702,-0.091 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9977"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1667,57.0529 1.2572,0.0788 11.5181,0.1017 -0.0408,0.6272 -11.5709,-0.0433 c -0.4043,-0.0409 -0.766,-0.0501 -1.1703,-0.091 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9979"
                inkscape:connector-curvature="0"
              />
              <path
                d="m 481.1685,59.556 1.2572,0.0787 11.5181,0.1017 -0.0408,0.5005 -11.5709,-0.0433 c -0.4043,-0.0409 -0.766,-0.0501 -1.1702,-0.091 z"
                style="fill:#333333;fill-rule:evenodd"
                id="path9981"
                inkscape:connector-curvature="0"
              />
            </g>
            <path
              d="m 493.0888,49.2019 h 3.4207 c 0.636,3.518 0.7227,7.6904 0,12.7868 h -3.4207 c 0.8816,-4.0859 0.9212,-8.3403 0,-12.7868 z"
              style="fill:#939ea3;fill-rule:evenodd"
              id="path9984"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 481.0212,47.7507 v 2.6873 h 13.3351 v -2.6873 z"
              style="fill:#676a6c;fill-rule:evenodd"
              id="path9986"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 480.7255,46.7535 v 0.9972 h 13.9266 v -0.9972 z"
              style="fill:#b2c0cb;fill-rule:evenodd"
              id="path9988"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 481.3508,45.6106 h 12.5407 l 0.7606,1.1514 h -13.9266 z"
              style="fill:#939ea3;fill-rule:evenodd"
              id="path9990"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 490.7443,47.8206 a 1.2737,1.2737 0 0 1 1.2737,1.2737 1.2737,1.2737 0 1 1 -1.2737,-1.2737 z"
              style="fill:#3e4855;fill-rule:evenodd"
              id="path9992"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 490.7507,48.6084 a 0.6444,0.6444 0 0 1 0.6444,0.6444 0.6444,0.6444 0 1 1 -0.6444,-0.6444 z"
              style="fill:#000000;fill-rule:evenodd"
              id="path9994"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 476.5672,57.3949 c 0.5605,-0.0933 1.1211,-0.119 1.6816,-0.2123 0.4539,0.0116 0.8945,0.1021 1.3272,0.2408 l -0.009,0.5804 c -0.0878,0.2723 -0.4603,0.5266 -0.8636,0.5058 l -2.1359,-0.0664 z"
              style="fill:#ffffff;fill-rule:evenodd"
              id="path9996"
              inkscape:connector-curvature="0"
            />
            <path
              d="m 476.5672,53.4346 1.6816,0.2376 c 0.4432,-0.0936 0.8081,-0.183 1.2496,-0.3447 l -0.007,-0.4358 c -0.159,-0.213 -0.377,-0.3871 -0.7163,-0.4198 l -2.2077,-0.0011 z"
              style="fill:#ffffff;fill-rule:evenodd"
              id="path9998"
              inkscape:connector-curvature="0"
            />
          </g>
          <g
            v-if="Status > 0"
            style="fill:#676a6c;fill-opacity:1"
            id="Layer1176"
            transform="matrix(0.29048164,0,0,0.29048164,-94.570316,249.55309)"
            inkscape:label="Status"
          >
            <path
              id="path12017"
              style="fill:#676a6c;fill-opacity:1;fill-rule:evenodd"
              d="m 351.5252,149.3002 a 4.7693,4.7693 0 0 1 4.7693,4.7692 4.7693,4.7693 0 1 1 -4.7693,-4.7692 z"
              inkscape:connector-curvature="0"
            />
            <path
              id="path12019"
              style="fill:#676a6c;fill-opacity:1;stroke:#00ff00;stroke-width:1.41729999;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none"
              d="m 349.0807,153.6233 c 2.3218,1.954 1.394,3.8811 2.5855,3.1077 1.1914,-0.7735 1.9955,-3.584 2.3036,-5.2518"
              inkscape:connector-curvature="0"
            />
          </g>

          <g
            v-else
            id="g17670"
            transform="translate(15.384702,-0.98555639)"
            inkscape:label="Status"
          >
            <path
              inkscape:connector-curvature="0"
              d="m -7.8452534,293.91648 a 1.3853941,1.3853941 0 0 1 1.3853941,1.38536 1.3853941,1.3853941 0 1 1 -1.3853941,-1.38536 z"
              style="display:inline;fill:#676a6c;fill-opacity:1;fill-rule:evenodd;stroke-width:0.29048163"
              id="path12017"
            />
            <path
              d="m -8.0713691,295.28696 -0.5814383,-0.85476 h 0.4472602 l 0.3652625,0.56404 0.3677473,-0.56404 h 0.4348363 l -0.5814383,0.84979 0.6062861,0.88955 h -0.4472602 l -0.3901103,-0.59634 -0.3925951,0.59634 h -0.4348363 z"
              style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:2.48477888px;line-height:1.25;font-family:'Gotham Bold';-inkscape-font-specification:'Gotham Bold,  Bold';letter-spacing:0px;word-spacing:0px;fill:#ff0000;fill-opacity:1;stroke:none;stroke-width:0.06211947"
              id="path17661"
              inkscape:connector-curvature="0"
            />
          </g>
        </g>
      </svg>
      <p class="nome-bomba">{{ Nome }}</p>
    </div>
  </drr>
</template>

<script>
import drr from "@minogin/vue-drag-resize-rotate";
import datas from "../services/datas";
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Bomba",
  components: {
    drr
  },
  props: {
    ID: { type: String, default: "0" },
    Nome: { type: String, default: "Bomba" },
    Status: { type: String, default: "0" },
    Top: { type: String, default: "0" },
    Left: { type: String, default: "0" },
    Width: { type: String, default: "50" },
    Height: { type: String, default: "24" },
    Angle: { type: String, default: "0" },
    Enabled: { type: Boolean, default: false }
  },
  data() {
    return {
      vWidth: { type: String, default: "50" },
      vHeight: { type: String, default: "24" }
    };
  },
  methods: {
    rotate(pos) {
      let id = this.ID;
      datas
        .salvarAngulo(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | ANGLE: ${pos.angle} | TOP: ${pos.y} | LEFT: ${pos.x} | HEIGTH: ${pos.h} | WIDTH: ${pos.w}`,
            "rotate"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Rotate!\n${error}`);
        });
    },
    resize(pos) {
      this.vWidth = pos.w + "";
      this.vHeight = pos.h + "";
      let el = document.getElementById(`${this.ID}-svg`);
      el.style.width = `${this.vWidth}px`;
      el.style.height = `${this.vHeight}px`;
      let id = this.ID;
      datas
        .salvarTamanho(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | HEIGHT: ${pos.h} | WIDTH: ${pos.w} | ANGLE: ${pos.angle}`,
            "resize"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Resize!\n${error}`);
        });
    },
    drag(pos) {
      let id = this.ID;
      datas
        .salvarPosicao(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | TOP: ${pos.y} | LEFT: ${pos.x} | ANGLE: ${pos.angle}`,
            "drag"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Drag!\n${error}`);
        });
    }
  },
  mounted() {
    this.vWidth = this.Width + "";
    this.vHeight = this.Height + "";
  }
};
</script>

<style>
.component {
  position: absolute;
  height: 100px;
  width: 100px;
  cursor: move;
  z-index: 200;
}
.nome-bomba {
  margin: 0;
  text-align: center;
  font-weight: bolder;
  font-size: 12px;
  z-index: 1;
}
</style>
